module.exports = __webpack_public_path__ + "img/ejemplo.5847d174.png";